/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type NotificationMessageContextWire = {
    id: string;
    senderName?: string;
    channel: NotificationMessageContextWire.channel;
    createdAt: string;
    kind: NotificationMessageContextWire.kind;
    propertyId?: number;
    property?: {
        propertyType?: NotificationMessageContextWire.propertyType | null;
        propertySubtype?: NotificationMessageContextWire.propertySubtype | null;
        locality?: string | null;
        operation?: NotificationMessageContextWire.operation | null;
        salePriceAmount?: string | null;
        salePriceCurrency?: string | null;
        rentPriceAmount?: string | null;
        rentPriceCurrency?: string | null;
    };
};
export namespace NotificationMessageContextWire {
    export enum channel {
        WHATSAPP = 'whatsapp',
        EMAIL = 'email',
        SMS = 'sms',
    }
    export enum kind {
        TEXT = 'text',
        IMAGE = 'image',
        VIDEO = 'video',
        AUDIO = 'audio',
        FILE = 'file',
    }
    export enum propertyType {
        HOUSE = 'HOUSE',
        APARTMENT = 'APARTMENT',
        OFFICE = 'OFFICE',
        RETAIL = 'RETAIL',
        WAREHOUSE = 'WAREHOUSE',
        LAND = 'LAND',
        PARCEL = 'PARCEL',
        PARKING = 'PARKING',
        INDUSTRIAL = 'INDUSTRIAL',
        OTHER = 'OTHER',
    }
    export enum propertySubtype {
        STUDIO = 'STUDIO',
    }
    export enum operation {
        SALE = 'SALE',
        RENT = 'RENT',
        SALE_AND_RENT = 'SALE_AND_RENT',
        TEMPORARY_RENT = 'TEMPORARY_RENT',
    }
}

